import { forwardRef, type PropsWithChildren } from 'react';

import { body } from './XYChartTooltipTemplate.sty.js';
import { Flex } from '../../../../../layouts/flex/Flex.js';
import { useChartActionsMenu } from '../../../../core/components/series-action/hooks/useChartActionsMenu.js';
import {
  ChartTooltip,
  type ChartTooltipProps,
} from '../../../../core/components/tooltip/ChartTooltip/ChartTooltip.js';

/**
 * Defines the only the template for the XYChart tooltip
 * @internal
 */
export const XYChartTooltipTemplate = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ChartTooltipProps>
>(({ position, pinned, children }, ref) => {
  const {
    selectedItem: selectedItemId,
    actionsMenuRef,
    updateSelectedItem,
    onLeave,
  } = useChartActionsMenu();

  if (!position) {
    return null;
  }

  return (
    <ChartTooltip
      ref={ref}
      position={position}
      pinned={pinned}
      className={body}
      updatePositionWhenPinned={true}
      onMouseLeave={onLeave}
      actionSelectionValue={{
        selectedItemId,
        actionsMenuRef,
        updateSelectedItem,
      }}
    >
      <Flex flexDirection="column" gap={4}>
        {children}
      </Flex>
    </ChartTooltip>
  );
});

(
  XYChartTooltipTemplate as typeof XYChartTooltipTemplate & {
    displayName: string;
  }
).displayName = 'XYChartTooltipTemplate';
